import Uoms from './Uoms'

export default Uoms



// WEBPACK FOOTER //
// ./src/components/Uoms/index.js